import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';

import styles from './RadioButtonOption.module.scss';

const RadioButtonOption = ({
  onChange,
  fluid,
  label,
  value,
  active,
  dataHook = '',
  type = 'normal',
  size = 'normal',
  theme = 'light'
}) => {
  const mainClass = classNames({
    [styles.main]: true,
    [styles[`main--${theme}`]]: true,
    [styles[`main--${type}`]]: !!type,
    [styles[`main--${size}`]]: !!size,
    [styles['main--active']]: active,
    [styles['main--fluid']]: fluid,
  });

  return (
    <button
      className={mainClass}
      data-hook={dataHook}
      onClick={() => onChange(value)}
    >
      {label}
    </button>
  );
};

RadioButtonOption.propTypes = {
  onChange: PropTypes.func,
  active: PropTypes.bool,
  fluid: PropTypes.bool,
  dataHook: PropTypes.string,
  label: PropTypes.string.isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.bool, PropTypes.number]).isRequired,
  theme: PropTypes.oneOf(['light', 'dark']),
  type: PropTypes.oneOf(['normal', 'filled']),
  size: PropTypes.oneOf(['large', 'normal', 'compact']),
};

export default RadioButtonOption;
